// Single source of truth for the guided Expert Engagement help categories.
// Keys must match the backend ENGAGE_CATEGORY_KEYS in Server/src/routes/engagement.py.
// Ordered by where the need normally arises in an application's life — designing it, then
// building, wiring, hardening, shipping and finally growing it — so the list reads as a
// progression rather than an arbitrary menu. Keys are unchanged, only the order.

export interface EngageCategory {
  key: string;
  label: string;
  example: string;
}

export const ENGAGE_CATEGORIES: EngageCategory[] = [
  { key: "architecture", label: "Architecture review", example: "Check my structure before I build further on it" },
  { key: "feature", label: "Build a feature", example: "Add a specific capability to my app" },
  { key: "integration", label: "Integration", example: "Wire in Stripe, a 3rd-party API, etc." },
  { key: "security", label: "Security advice", example: "Harden auth, secrets, and data handling" },
  { key: "deployment", label: "Deployment help", example: "Get my app to production / fix a failing deploy" },
  { key: "scaling", label: "Scaling", example: "Handle 10k+ users, performance tuning" },
  { key: "other", label: "Something else", example: "Tell us what you need" },
];

export const ENGAGE_CATEGORY_KEYS = ENGAGE_CATEGORIES.map((c) => c.key);
